import React from 'react';

function PageHeader({ title, subtitle, icon }) {
	return (
		<section className="page-header">
			<div className="container" style={{ display: 'flex', gap: 14, alignItems: 'center', flexWrap: 'wrap' }}>
				<div className="icon-circle" aria-hidden="true">
					{icon || (
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M4 19h16M12 5v14M7 9h10M9 13h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
						</svg>
					)}
				</div>
				<div>
					<h1 className="page-header-title">{title}</h1>
					{subtitle && <p className="helper" style={{ margin: 0 }}>{subtitle}</p>}
				</div>
			</div>
		</section>
	);
}

export default PageHeader;


